import React, { useEffect, useState } from "react";
import { Checkbox, Select, TextInput } from "../../form/inputs";
import { icons, Plus } from "lucide-react";
import dishImg from "../../../assets/images/imgLibrary/01.png";
import CalendarInput from "../../form/CalendarInput";
import { GoMoon, GoSun } from "react-icons/go";
import InputBase from "../../form/inputs/InputBase";
import { AlertTriangle } from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { saveOrderDraft } from "../../../redux/slices/orderDraftSlice";
import {
  getCustomerDetail,
  getAllMealOnOrder,
  verifyOrderStartDate,
} from "../../../redux/thunks/orderCustomerThunk";
import SecondaryBtn from "../../button/SecondaryBtn";
import toast from "react-hot-toast";
import AddorderShimmer from "../../Preloader/AddorderShimmer";
import OnaddressRangeModal from "../../Modals/OnaddressRangeModal";
import RadioCardGroup from "../../button/RadioCardGroup";
import { encryptId } from "../../../utils/urlCrypto";

const Addform = ({ setTab }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [isDateAvailable, setIsDateAvailable] = useState(true);
  const { draft } = useSelector((state) => state.orderDraft);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [HomeDeliveryStatus, setHomeDeliveryStatus] = useState(false);
  const { isOrderLoading } = useSelector((state) => state.customerOrder);
  const [date, setDate] = useState(draft?.order?.date || "");
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [allMeals, setAllMeals] = useState([]);
  const [selectedMealId, setSelectedMealId] = useState(draft?.meal?.id || null);
  const [extraItemsQty, setExtraItemsQty] = useState(() => {
    if (!draft) return {};

    const source =
      draft?.extra_Item?.length > 0
        ? draft.extra_Item
        : draft?.extraItems?.length > 0
          ? draft.extraItems
          : [];

    const obj = {};

    source.forEach((item) => {
      const id = item?.extra_item_id; // ✅ ONLY this
      const quantity = item?.quantity ?? item?.qty ?? 0;

      if (id) {
        obj[id] = Number(quantity) || 0;
      }
    });

    return obj;
  });

  const [mealQty, setMealQty] = useState(draft?.meal?.qty || 1);
  const [orderAmount, setOrderAmount] = useState("");
  const [getDelCharge, setGetDelCharge] = useState("");
  const [spCustomAddId, setSpCustomAddId] = useState(null);
  const [mealType, setMealType] = useState(draft?.order?.mealTiming || "");
  const [deliveryType, setDeliveryType] = useState(
    draft?.order?.deliveryType || "",
  );

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectCustomerFrom, setSelectCustomerFrom] = useState(
    draft?.customer?.selectedCustomerId || "",
  );
  const [customer, setCustomer] = useState([]);

  const customerId = location?.state?.customerId;

  const [extraItemId, setExtraItemId] = useState("");

  const [showOutOfRangeModal, setShowOutOfRangeModal] = useState(false);
  const [allowOutOfRange, setAllowOutOfRange] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [selectedLunch, setSelectedLunch] = useState("");
  const [selectedDinner, setSelectedDinner] = useState("");
  const [notes, setNotes] = useState("");
  const [lunchSlots, setLunchSlots] = useState([]);
  const [dinnerSlots, setDinnerSlots] = useState([]);
  const [IsDinnerslotsAvailable, setIsDinnerslotsAvailable] = useState(false);
  const [IsLunchSlotsAvailable, setIsLunchSlotsAvailable] = useState(false);
  const [isLunchAvailable, setIsLunchAvailable] = useState(true);
  const [isDinnerAvailable, setIsDinnerAvailable] = useState(true);
  // useEffect(() => {
  //   console.log("The customer id got is :", customerId);
  // }, [customerId]);

  useEffect(() => {
    if (customer.length > 0) return;

    dispatch(getCustomerDetail())
      .unwrap()
      .then((res) => {
        // console.log("The res to check customer details", res.data);
        const getCurrencySymbol = res.data?.currency_symbol;
        setCurrencySymbol(getCurrencySymbol);
        const allCustomers = res.data?.customers || [];

        setCustomer(allCustomers);
        setGetDelCharge(res.data?.delivery_charges);
        setHomeDeliveryStatus(res.data?.is_home_delivery);
        const getdinnerSlots = res.data?.dinner_time_slot.length > 0;
        setIsDinnerslotsAvailable(getdinnerSlots);

        const getLunchSlots = res.data?.lunch_time_slot.length > 0;
        setIsLunchSlotsAvailable(getLunchSlots);

        const targetCustomerId = draft?.customer?.id || customerId;

        const foundCustomer = allCustomers.find(
          (c) => String(c.customer_id) === String(targetCustomerId),
        );

        setSelectedCustomer(foundCustomer || null);
        setSelectCustomerFrom(targetCustomerId || ""); // ✅ ADD THIS
        setSelectedCustomer(foundCustomer || null);

        // 🔥 Restore Address from draft if exists
        if (draft?.address?.id && foundCustomer?.addresses) {
          const addr = foundCustomer.addresses.find(
            (a) => String(a.address_id) === String(draft.address.id),
          );

          setSelectedAddress(addr || null);
          setSpCustomAddId(addr?.address_id || null);
        } else {
          // fallback default address
          const defaultAddress =
            foundCustomer?.addresses?.find((a) => a.is_default) ||
            foundCustomer?.addresses?.[0] ||
            null;

          setSelectedAddress(defaultAddress);
          setSpCustomAddId(defaultAddress?.address_id || null);
        }

        // 🔥 SET TIME SLOTS FROM API
        const lunchFromApi = res.data?.lunch_time_slot || [];
        const dinnerFromApi = res.data?.dinner_time_slot || [];

        // Convert string array → { value, label }
        const formattedLunch = lunchFromApi.map((slot) => ({
          value: slot,
          label: slot,
        }));

        const formattedDinner = dinnerFromApi.map((slot) => ({
          value: slot,
          label: slot,
        }));

        setLunchSlots(formattedLunch);
        setDinnerSlots(formattedDinner);
      })
      .catch(console.error);
  }, [dispatch, customer.length]);

  // Get meals
  useEffect(() => {
    // 🔒 Prevent refetch if meals already loaded
    if (allMeals.length > 0) return;

    dispatch(getAllMealOnOrder())
      .unwrap()
      .then((res) => {
        // console.log("The res to check Meal details", res.data);
        const mealsFromApi = res?.data || [];

        setAllMeals(mealsFromApi);

        // ✅ Restore selected meal if draft exists
        if (draft?.meal?.id && mealsFromApi.length > 0) {
          const mealData = mealsFromApi.find(
            (meal) => String(meal.meal_id) === String(draft.meal.id),
          );

          if (mealData) {
            setSelectedMeal(mealData);
            setSelectedMealId(mealData.meal_id);
            setMealQty(draft.meal.qty || 1);
          }
        }
      })
      .catch((err) => {
        console.error("Meal fetch failed", err);
      });
  }, [dispatch, allMeals.length, draft]);

  const customerOptions = customer.map((c) => ({
    label: `${c.customer_name} (+${c.country_code} ${c.contact_no})`,
    value: c.customer_id,
  }));

  const mealOptions = allMeals.map((meal) => ({
    label: meal.meal_name,
    value: meal.meal_id,
  }));

  const handleMealSelect = (e) => {
    const mealId = Number(e.target.value);
    setSelectedMealId(mealId);

    const mealData = allMeals.find((meal) => meal.meal_id === mealId);
    setSelectedMeal(mealData || null);

    if (mealData) {
      setOrderAmount(mealData.trial_serving_cost);
    }

    setErrors((prev) => ({ ...prev, selectedMeal: "" }));
  };

  const increaseMealQty = () => {
    setMealQty((prev) => prev + 1);
  };

  const decreaseMealQty = () => {
    setMealQty((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const increaseQty = (id) => {
    setExtraItemsQty((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const decreaseQty = (id) => {
    setExtraItemsQty((prev) => ({
      ...prev,
      [id]: Math.max((prev[id] || 0) - 1, 0),
    }));
  };

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  useEffect(() => {
    if (!selectedMeal) return;

    let total = 0;

    // meal amount × quantity
    total += Number(selectedMeal.trial_serving_cost) * mealQty;

    // extra items
    const extraItemIds = selectedMeal.extra_items?.map(
      (item) => item.extra_item_id,
    );

    setExtraItemId(extraItemIds);

    // console.log("Extra item ids :", extraItemIds);

    selectedMeal?.extra_items?.forEach((item) => {
      const qty = extraItemsQty[item.extra_item_id] || 0;
      total += Number(item.amount) * qty;
    });

    // delivery charge
    if (deliveryType === "delivery") {
      total += Number(getDelCharge || 0);
    }

    setOrderAmount(total);
  }, [selectedMeal, mealQty, extraItemsQty, deliveryType, getDelCharge]);

  // Restore selected address
  useEffect(() => {
    let addr = null;

    // 1️⃣ If coming back from address page
    if (location.state?.selectedAddress) {
      addr = location.state.selectedAddress;
    }
    // 2️⃣ Else use draft
    else if (draft?.address?.id && selectedCustomer?.addresses) {
      addr = selectedCustomer.addresses.find(
        (a) => String(a.address_id) === String(draft.address.id),
      );
    }
    // 3️⃣ Fallback default address
    else if (selectedCustomer?.addresses?.length > 0) {
      addr =
        selectedCustomer.addresses.find((a) => a.is_default) ||
        selectedCustomer.addresses[0];
    }

    if (addr) {
      setSelectedAddress(addr);
      setSpCustomAddId(addr.address_id);
    }
  }, [location.state, draft, selectedCustomer]);

  const validateFields = () => {
    const newErrors = {};

    // ✅ Customer required
    if (!selectedCustomer && !selectCustomerFrom) {
      newErrors.customer = "Please select customer first";
    }

    // ✅ Meal required
    if (!selectedMeal) {
      newErrors.selectedMeal = "Please select a meal";
    }

    // ✅ Date required
    if (!date) {
      newErrors.date = "Please select order date";
    }

    // ✅ Time slot validation ONLY if slots available
    if (mealType === "lunch" && IsLunchSlotsAvailable) {
      if (!selectedLunch) {
        newErrors.timeSlot = "Please select lunch time slot";
      }
    }

    if (mealType === "dinner" && IsDinnerslotsAvailable) {
      if (!selectedDinner) {
        newErrors.timeSlot = "Please select dinner time slot";
      }
    }

    if (!mealType) {
      newErrors.mealTimingAvailability = "Please select meal timing";
    }

    // ✅ Delivery type required
    if (!deliveryType) {
      newErrors.deliveryType = "Please select delivery type";
    }

    // ✅ If delivery selected → address required
    if (deliveryType === "delivery") {
      if (!selectedCustomer) {
        newErrors.customer = "Please select customer first";
      }

      if (!selectedAddress) {
        newErrors.address = "Please select delivery address";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const proceedToNextStep = () => {
    const formattedExtraItems =
      selectedMeal.extra_items
        ?.filter(
          (item) => item.extra_item_id && extraItemsQty[item.extra_item_id] > 0,
        )
        .map((item) => ({
          meal_extra_item_id: item.meal_extra_item_id,
          extra_item_id: item.extra_item_id,
          quantity: extraItemsQty[item.extra_item_id],
        })) || [];

    const draftData = {
      // CUSTOMER UI
      cSymbol: currencySymbol,
      customer: {
        id: selectCustomerFrom || customerId,
        selectedCustomerId: selectCustomerFrom || customerId,
        name: selectedCustomer?.customer_name,
        phone: `+${selectedCustomer?.country_code} ${selectedCustomer?.contact_no}`,
        initials: getInitials(selectedCustomer?.customer_name),
      },

      // MEAL UI
      meal: {
        id: selectedMealId,
        name: selectedMeal?.meal_name,
        image: selectedMeal?.meal_cover_image,
        price: selectedMeal?.trial_serving_cost,
        qty: mealQty,
        description: selectedMeal?.meal_description,
      },

      // EXTRA ITEMS UI
      extra_Item: formattedExtraItems,
      extraItems: selectedMeal.extra_items
        ?.filter((item) => extraItemsQty[item.extra_item_id] > 0)
        .map((item) => ({
          name: item.name,
          qty: extraItemsQty[item.extra_item_id],
          amount: item.amount,
          total: item.amount * extraItemsQty[item.extra_item_id],
          meal_extra_item_id: item.meal_extra_item_id,
        })),

      // ORDER META
      order: {
        date,
        mealTiming: mealType,
        timeSlot:
          mealType === "lunch"
            ? selectedLunch
            : mealType === "dinner"
              ? selectedDinner
              : "",
        deliveryType,
        planType: "Trial (1 Meal)",
      },

      // ADDRESS UI
      address:
        deliveryType === "delivery"
          ? {
              id: spCustomAddId,
              fullAddress: selectedAddress
                ? `${selectedAddress.address_1}, ${selectedAddress.address_2 || ""}`
                : "",
              latitude: selectedAddress?.latitude,
              longitude: selectedAddress?.longitude,
            }
          : null,
      addressId: spCustomAddId,

      // AMOUNT BREAKDOWN
      pricing: {
        mealTotal: selectedMeal.trial_serving_cost * mealQty,
        extrasTotal:
          orderAmount -
          selectedMeal.trial_serving_cost * mealQty -
          (deliveryType === "delivery" ? Number(getDelCharge) : 0),
        deliveryCharge: deliveryType === "delivery" ? getDelCharge : 0,
        discount: 5, // example
        finalAmount: orderAmount,
      },
      orderRemark: notes,
    };
    // console.log("The form data is :", draftData);
    // 🔥 Your existing draftData code here
    dispatch(saveOrderDraft(draftData));
    setTab(1);
  };

  const handleOnContinue = async () => {
    const isValid = validateFields();

    if (!isValid) {
      return;
    }

    if (
      deliveryType === "delivery" &&
      selectedAddress &&
      selectedAddress.is_on_delivery_distance === 0 &&
      !allowOutOfRange
    ) {
      setShowOutOfRangeModal(true);
      return; // 🚫 stop here
    }

    proceedToNextStep();
  };

  useEffect(() => {
    if (!selectedMeal) return;

    const formattedExtraItems =
      selectedMeal.extra_items
        ?.filter(
          (item) => item.extra_item_id && extraItemsQty[item.extra_item_id] > 0,
        )
        .map((item) => ({
          meal_extra_item_id: item.meal_extra_item_id,
          extra_item_id: item.extra_item_id,
          quantity: extraItemsQty[item.extra_item_id],
        })) || [];

    const draftData = {
      // CUSTOMER UI
      cSymbol: currencySymbol,
      customer: {
        id: selectCustomerFrom || customerId,
        selectedCustomerId: selectCustomerFrom || customerId,
        name: selectedCustomer?.customer_name,
        phone: `+${selectedCustomer?.country_code} ${selectedCustomer?.contact_no}`,
        initials: getInitials(selectedCustomer?.customer_name),
      },

      // MEAL UI
      meal: {
        id: selectedMealId,
        name: selectedMeal?.meal_name,
        image: selectedMeal?.meal_cover_image,
        price: selectedMeal?.trial_serving_cost,
        qty: mealQty,
        description: selectedMeal?.meal_description,
      },

      // EXTRA ITEMS UI
      extra_Item: formattedExtraItems,
      extraItems: selectedMeal.extra_items
        ?.filter((item) => extraItemsQty[item.extra_item_id] > 0)
        .map((item) => ({
          name: item.name,
          qty: extraItemsQty[item.extra_item_id],
          amount: item.amount,
          total: item.amount * extraItemsQty[item.extra_item_id],
          meal_extra_item_id: item.meal_extra_item_id,
        })),

      // ORDER META
      order: {
        date,
        mealTiming: mealType,
        timeSlot:
          mealType === "lunch"
            ? selectedLunch
            : mealType === "dinner"
              ? selectedDinner
              : "",
        deliveryType,
        planType: "Trial (1 Meal)",
      },
      // ADDRESS UI
      address:
        deliveryType === "delivery"
          ? {
              id: spCustomAddId,
              fullAddress: selectedAddress
                ? `${selectedAddress.address_1}, ${selectedAddress.address_2 || ""}`
                : "",
              latitude: selectedAddress?.latitude,
              longitude: selectedAddress?.longitude,
            }
          : null,
      addressId: spCustomAddId,

      // AMOUNT BREAKDOWN
      pricing: {
        mealTotal: selectedMeal.trial_serving_cost * mealQty,
        extrasTotal:
          orderAmount -
          selectedMeal.trial_serving_cost * mealQty -
          (deliveryType === "delivery" ? Number(getDelCharge) : 0),
        deliveryCharge: deliveryType === "delivery" ? getDelCharge : 0,
        discount: 0, // example
        finalAmount: orderAmount,
      },
      orderRemark: notes,
    };

    dispatch(saveOrderDraft(draftData));
  }, [
    selectedCustomer,
    selectedMeal,
    selectedMealId,
    mealQty,
    extraItemsQty,
    mealType,
    deliveryType,
    selectedAddress,
    date,
    orderAmount,
    getDelCharge,
    dispatch,
  ]);

  const toYYYYMMDD = (date) => {
    const d = new Date(date);
    if (isNaN(d)) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (!date || !selectedMealId) return;

    const verifyDate = async () => {
      try {
        const payload = {
          meal_id: selectedMealId,
          meal_plan_type: "trial",
          order_date: toYYYYMMDD(date),
        };

        const dateRes = await dispatch(verifyOrderStartDate(payload)).unwrap();

        if (!dateRes?.success) {
          setIsDateAvailable();
          setMealType("");
          setIsLunchAvailable();
          setIsDinnerAvailable();

          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability: `Meal is not available for ${payload.order_date}`,
          }));
          return;
        }

        // ✅ API SUCCESS
        setIsDateAvailable(true);

        const lunchAvailable = dateRes?.data?.isLunch;

        // console.log("The lunch is :", lunchAvailable);

        const dinnerAvailable = dateRes?.data?.isDinner;

        // console.log("The dinner is :", dinnerAvailable);

        setIsLunchAvailable(lunchAvailable);
        setIsDinnerAvailable(dinnerAvailable);

        // ❌ If both false → show error
        if (!lunchAvailable && !dinnerAvailable) {
          setMealType("");
          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability:
              "No meal timing available for selected date",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability: "",
          }));
        }

        // 🔥 If currently selected mealType becomes invalid → reset it
        if (mealType === "lunch" && !lunchAvailable) {
          setMealType("");
          setSelectedLunch("");
        }

        if (mealType === "dinner" && !dinnerAvailable) {
          setMealType("");
          setSelectedDinner("");
        }
      } catch (err) {
        setIsDateAvailable(false);
        setMealType("");
        setIsLunchAvailable(false);
        setIsDinnerAvailable(false);

        setErrors((prev) => ({
          ...prev,
          mealTimingAvailability: "Unable to verify selected date",
        }));
      }
    };

    verifyDate();
  }, [selectedMealId, date, dispatch]);

  const targetCustomerId = customerId || selectCustomerFrom;

  const hasAddress =
    Array.isArray(selectedCustomer?.addresses) &&
    selectedCustomer.addresses.length > 0;

  // useEffect(() => {
  //   console.log("The customer manual address id is :", selectedAddress);
  //   console.log(
  //     "The customer selected address id after chnage address is :",
  //     spCustomAddId,
  //   );
  // }, [selectedAddress, spCustomAddId]);

  return (
    <>
      {isOrderLoading ? (
        <AddorderShimmer />
      ) : (
        <>
          <div className="flex flex-col justify-center space-y-4">
            {/* Select customers */}
            <div className="w-full">
              <div>
                {location?.state?.from === "order" ? (
                  <>
                    <Select
                      label="Customer"
                      value={selectCustomerFrom}
                      onChange={(val) => {
                        setSelectCustomerFrom(val);
                        const cust = customer.find(
                          (c) => String(c.customer_id) === String(val),
                        );

                        setSelectedCustomer(cust || null);

                        // 🔥 Reset delivery & address on customer change
                        setDeliveryType("");
                        setSelectedAddress(null);
                        setSpCustomAddId(null);
                      }}
                      options={customerOptions}
                    />
                    {customer.length <= 0 && (
                      <p className="text-xs text-red-500 mt-1">
                        No customers found, please add customer first
                      </p>
                    )}
                    {errors.customer && (
                      <p className="text-xs text-red-500 mt-1">
                        {errors.customer}
                      </p>
                    )}

                    <NavLink
                      to={"/add-new-customer"}
                      className="text-[#FF6943] mt-4 text-sm font-medium hover:underline cursor-pointer flex items-center justify-end gap-2"
                    >
                      <span className="border border-[#FF6943] rounded-md flex items-center justify-center w-4 h-4">
                        <Plus size={12} />
                      </span>
                      Add New Customers
                    </NavLink>
                  </>
                ) : (
                  selectedCustomer && (
                    <div className="bg-white p-4 hover:shadow-md duration-300 border border-gray-100 rounded-xl">
                      <div className="flex items-center gap-4">
                        <div className="h-12 w-12 flex items-center justify-center rounded-xl bg-[#FFEFEB] border border-[#FFCCBF] text-[#FF6943] font-semibold">
                          {getInitials(selectedCustomer.customer_name) || ""}
                        </div>
                        <div>
                          <h2 className="text-base font-semibold">
                            {selectedCustomer.customer_name || ""}
                          </h2>
                          <p className="text-sm text-gray-500 flex gap-2 justify-start items-center">
                            <FiPhoneCall />+
                            {selectedCustomer.country_code || ""}{" "}
                            {selectedCustomer.contact_no || ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            {/* Select meal */}
            <div className="w-full">
              <div>
                <Select
                  label="Select Meal"
                  required={true}
                  value={selectedMealId}
                  onChange={(val) =>
                    handleMealSelect({ target: { value: val } })
                  }
                  options={mealOptions}
                />
                {errors.selectedMeal && (
                  <p className="text-xs text-red-500 mt-1">
                    {errors.selectedMeal}
                  </p>
                )}
              </div>
            </div>
            {/* Users info */}
            {selectedMeal && (
              <div className="mt-4 border border-gray-100 rounded-md p-4">
                <div className="flex items-center justify-between gap-4">
                  {/* Left */}
                  <div className="flex items-center gap-4">
                    <img
                      src={selectedMeal.meal_cover_image}
                      alt={selectedMeal.meal_name}
                      className="w-12 h-12 rounded-md object-cover"
                    />

                    <div>
                      <h2 className="text-base font-semibold">
                        {selectedMeal.meal_name}
                      </h2>
                      <p className="text-[#FF6943] font-bold">
                        {currencySymbol} {selectedMeal.trial_serving_cost}
                      </p>
                    </div>
                  </div>

                  {/* Right - Quantity */}
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      onClick={decreaseMealQty}
                      className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                    >
                      −
                    </button>

                    <span className="border h-8 w-8 rounded-md flex items-center justify-center text-sm">
                      {mealQty}
                    </span>

                    <button
                      type="button"
                      onClick={increaseMealQty}
                      className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                    >
                      +
                    </button>
                  </div>
                </div>

                <p className="mt-2 text-sm text-gray-500">
                  {selectedMeal.meal_description}
                </p>
              </div>
            )}
            {/* Extra items */}
            {selectedMeal?.extra_items?.length > 0 && (
              <div className="mt-2">
                <p>Extra items</p>

                {selectedMeal.extra_items.map((item) => (
                  <div
                    key={item.extra_item_id}
                    className="border border-gray-100 p-4 rounded-md mt-3"
                  >
                    <div className="flex  sm:flex-row  justify-between gap-4">
                      {/* Left */}
                      <div className="flex flex-col">
                        <p className="text-sm sm:text-base text-gray-700">
                          {item.name}
                        </p>
                        <p className="mt-1 font-bold text-[#FF6943] text-sm sm:text-base">
                          {currencySymbol} {item.amount}
                        </p>
                      </div>

                      {/* Right */}
                      <div className="flex items-center gap-3">
                        <button
                          type="button"
                          onClick={() => decreaseQty(item.extra_item_id)}
                          className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                        >
                          −
                        </button>

                        <span className="border h-8 w-8 rounded-md flex items-center justify-center text-sm">
                          {extraItemsQty[item.extra_item_id] || 0}
                        </span>

                        <button
                          type="button"
                          onClick={() => increaseQty(item.extra_item_id)}
                          className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {/* Plan type */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
              {/* Trial info */}
              <div>
                <p className="text-sm text-gray-800 text-start mb-2">
                  Plan Type <span className="text-red-500 ml-1">*</span>
                </p>
                <div className="border border-gray-200 rounded-xl bg-gray-50 p-3 flex items-center">
                  <p className="text-sm font-medium text-gray-800">
                    Trial <span className="text-gray-500">(1 Meal)</span>
                  </p>
                </div>
              </div>

              {/* Calendar */}
              <div className="w-full">
                <CalendarInput
                  required={true}
                  label="Order date"
                  variant="trial"
                  value={date}
                  onChange={(val) => {
                    setDate(val);
                    setIsDateAvailable(true);
                    setErrors((prev) => ({
                      ...prev,
                      date: "",
                      mealTimingAvailability: "",
                    }));
                  }}
                />

                {errors.date && (
                  <p className="text-xs text-red-500 mt-1">{errors.date}</p>
                )}
              </div>
            </div>
            {/* Meal Timing */}
            <div>
              <p className="text-sm text-gray-800 text-start">
                Meal Timing <span className="text-red-500 ml-1">*</span>
              </p>

              <div className="flex gap-3 flex-wrap mt-4">
                <Checkbox
                  variant="radio"
                  label="Lunch"
                  name="mealType"
                  disabled={!isDateAvailable || !isLunchAvailable}
                  icon={<GoSun />}
                  checked={mealType === "lunch"}
                  onChange={() => {
                    setMealType("lunch");
                    setSelectedDinner("");
                    setErrors((prev) => ({
                      ...prev,
                      mealTimingAvailability: "",
                    }));
                  }}
                />

                <Checkbox
                  variant="radio"
                  label="Dinner"
                  name="mealType"
                  disabled={!isDateAvailable || !isDinnerAvailable}
                  icon={<GoMoon />}
                  checked={mealType === "dinner"}
                  onChange={() => {
                    setMealType("dinner");
                    setSelectedLunch("");
                    setErrors((prev) => ({
                      ...prev,
                      mealTimingAvailability: "",
                    }));
                  }}
                />
              </div>

              {errors.mealTimingAvailability && (
                <p className="text-xs text-red-500 mt-2">
                  {errors.mealTimingAvailability}
                </p>
              )}
            </div>
            <div className="w-full max-w-md space-y-3 mt-4">
              {/* Lunch Slot */}
              {mealType === "lunch" && IsLunchSlotsAvailable && (
                <>
                  <p className="text-sm text-gray-800 text-start">
                    Lunch Time Slot <span className="text-red-500 ml-1">*</span>
                  </p>

                  <RadioCardGroup
                    options={lunchSlots}
                    name="lunchSlot"
                    selectedValue={selectedLunch}
                    onChange={(value) => {
                      setSelectedLunch(value);
                      setErrors((prev) => ({
                        ...prev,
                        timeSlot: "",
                      }));
                    }}
                    variant="lunch"
                  />
                </>
              )}

              {/* Dinner Slot */}
              {mealType === "dinner" && IsDinnerslotsAvailable && (
                <>
                  <p className="text-sm text-gray-800 text-start">
                    Dinner Time Slot{" "}
                    <span className="text-red-500 ml-1">*</span>
                  </p>

                  <RadioCardGroup
                    options={dinnerSlots}
                    name="dinnerSlot"
                    selectedValue={selectedDinner}
                    onChange={(value) => {
                      setSelectedDinner(value);
                      setErrors((prev) => ({
                        ...prev,
                        timeSlot: "",
                      }));
                    }}
                    variant="dinner"
                  />
                </>
              )}

              {errors.timeSlot && (
                <p className="text-xs text-red-500 mt-2">{errors.timeSlot}</p>
              )}
            </div>
            {/* Delivery type and Adding new Address */}
            <div className="mt-4">
              <p className="text-sm text-gray-800 text-start">
                Delivery Type <span className="text-red-500 ml-1">*</span>
              </p>
              <div className="flex gap-3 flex-wrap mt-4">
                <Checkbox
                  variant="radio"
                  label="Home delivery"
                  name="delivery"
                  checked={deliveryType === "delivery"}
                  disabled={!HomeDeliveryStatus}
                  onChange={() => {
                    if (!selectedCustomer) {
                      setErrors((prev) => ({
                        ...prev,
                        customer: "Please select customer first",
                      }));
                      return;
                    }

                    setDeliveryType("delivery");

                    const defaultAddr =
                      selectedCustomer?.addresses?.find((a) => a.is_default) ||
                      selectedCustomer?.addresses?.[0];

                    setSelectedAddress(defaultAddr);
                    setSpCustomAddId(defaultAddr?.address_id);

                    setErrors((prev) => ({
                      ...prev,
                      deliveryType: "",
                      customer: "",
                    }));
                  }}
                  onDisabledClick={() =>
                    toast.error("Home delivery is not available right now")
                  }
                />
                <Checkbox
                  variant="radio"
                  label="Pickup"
                  name="pickup"
                  checked={deliveryType === "pickup"}
                  onChange={(e) => setDeliveryType(e.target.name)}
                />
              </div>
              {deliveryType === "delivery" && selectedCustomer && (
                <p className="text-xs text-start text-[#FF6943] mt-2">
                  Delivery Charges : ${getDelCharge}
                </p>
              )}
              {errors.deliveryType && (
                <p className="text-xs text-red-500 mt-2">
                  {errors.deliveryType}
                </p>
              )}
            </div>
            {deliveryType === "delivery" && (
              <>
                {!selectedCustomer ? null : !hasAddress ? (
                  <button
                    type="button"
                    onClick={() =>
                      navigate(
                        `/customer/add-customers-address/${encryptId(targetCustomerId)}`,
                      )
                    }
                    className="w-full flex items-center justify-center gap-2 text-sm font-medium text-[#FF6943] border border-dashed rounded-xl py-3 hover:bg-orange-50"
                  >
                    <span className="text-lg">＋</span> Add New Address
                  </button>
                ) : (
                  <InputBase
                    type="textarea"
                    variant="location"
                    onChange={() => {}}
                    rows={2}
                    readOnly
                    onChangeLocation={() =>
                      navigate(`/address/${encryptId(targetCustomerId)}`, {
                        state: { from: "addOrder" },
                      })
                    }
                    value={
                      selectedAddress
                        ? `${selectedAddress.address_1}${selectedAddress.address_2 ? ", " + selectedAddress.address_2 : ""}`
                        : ""
                    }
                  />
                )}
              </>
            )}

            <div>
              <InputBase
                label={"Order Remark"}
                type="textarea"
                rows={2}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>

            {selectedMeal && (
              <div>
                <p>Per order Amount</p>
                <div className="relative shrink-0 w-full mt-2">
                  <span className="absolute inset-y-0 left-0 flex items-center px-3 text-red-500 bg-red-50 border border-r-0 border-red-200 rounded-l-md text-sm font-medium">
                    {currencySymbol}
                  </span>

                  <input
                    type="text"
                    value={orderAmount}
                    disabled
                    className="
                    w-full
                    pl-10 pr-2 py-2
                    text-start text-sm
                    border border-red-200
                    rounded-md
                    outline-none
                    focus:ring-2 focus:ring-red-200
                    "
                  />
                </div>
              </div>
            )}

            <div className="mt-2 md:mt-12 flex justify-center items-center md:justify-end">
              <SecondaryBtn btnName="Continue" clickEvent={handleOnContinue} />
            </div>
          </div>
        </>
      )}

      {showOutOfRangeModal && (
        <OnaddressRangeModal
          open={showOutOfRangeModal}
          onClose={() => setShowOutOfRangeModal(false)}
          onConfirm={() => {
            setAllowOutOfRange(true);
            proceedToNextStep();
          }}
        />
      )}
    </>
  );
};

export default Addform;
